/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ApiKeyCreateRequest,
  ApiKeyCreateResponse,
  ApiKeyListItem,
  HTTPValidationError,
  RevokeApiKeyApiApiKeysKeyIdDelete200,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listApiKeysApiApiKeysGetResponse200 = {
  data: ApiKeyListItem[];
  status: 200;
};

export type listApiKeysApiApiKeysGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listApiKeysApiApiKeysGetResponseSuccess =
  listApiKeysApiApiKeysGetResponse200 & {
    headers: Headers;
  };
export type listApiKeysApiApiKeysGetResponseError =
  listApiKeysApiApiKeysGetResponse422 & {
    headers: Headers;
  };

export type listApiKeysApiApiKeysGetResponse =
  | listApiKeysApiApiKeysGetResponseSuccess
  | listApiKeysApiApiKeysGetResponseError;

export const getListApiKeysApiApiKeysGetUrl = () => {
  return `/api/api-keys`;
};

/**
 * List the team's gateway API keys (excluding the internal service key).
 * @summary List Api Keys
 */
export const listApiKeysApiApiKeysGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listApiKeysApiApiKeysGetResponse> => {
  return orvalFetch<listApiKeysApiApiKeysGetResponse>(
    getListApiKeysApiApiKeysGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListApiKeysApiApiKeysGetQueryKey = () => {
  return [`/api/api-keys`] as const;
};

export const getListApiKeysApiApiKeysGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListApiKeysApiApiKeysGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>
  > = ({ signal }) => listApiKeysApiApiKeysGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListApiKeysApiApiKeysGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>
>;
export type ListApiKeysApiApiKeysGetQueryError = ErrorType<HTTPValidationError>;

export function useListApiKeysApiApiKeysGet<
  TData = Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
          TError,
          Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListApiKeysApiApiKeysGet<
  TData = Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
          TError,
          Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListApiKeysApiApiKeysGet<
  TData = Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Api Keys
 */

export function useListApiKeysApiApiKeysGet<
  TData = Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listApiKeysApiApiKeysGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListApiKeysApiApiKeysGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createApiKeyApiApiKeysPostResponse201 = {
  data: ApiKeyCreateResponse;
  status: 201;
};

export type createApiKeyApiApiKeysPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createApiKeyApiApiKeysPostResponseSuccess =
  createApiKeyApiApiKeysPostResponse201 & {
    headers: Headers;
  };
export type createApiKeyApiApiKeysPostResponseError =
  createApiKeyApiApiKeysPostResponse422 & {
    headers: Headers;
  };

export type createApiKeyApiApiKeysPostResponse =
  | createApiKeyApiApiKeysPostResponseSuccess
  | createApiKeyApiApiKeysPostResponseError;

export const getCreateApiKeyApiApiKeysPostUrl = () => {
  return `/api/api-keys`;
};

/**
 * Create a new gateway API key. The secret is returned only here, once.
 *
 * Provisions the team's gateway record lazily if it doesn't exist yet, so a
 * team can mint its first user key before creating any models. The key gets
 * exactly the scopes the caller asked for (inference-only by default).
 * The audit log records the key's id, name and scopes, never the secret
 * (TRA-1626); the row is written after the gateway minted the key.
 * @summary Create Api Key
 */
export const createApiKeyApiApiKeysPost = async (
  apiKeyCreateRequest: ApiKeyCreateRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createApiKeyApiApiKeysPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createApiKeyApiApiKeysPostResponse>(
    getCreateApiKeyApiApiKeysPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(apiKeyCreateRequest),
    },
  );
};

export const getCreateApiKeyApiApiKeysPostMutationKey = () =>
  ["createApiKeyApiApiKeysPost"] as const;

export const getCreateApiKeyApiApiKeysPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiKeyApiApiKeysPost>>,
    TError,
    CreateApiKeyApiApiKeysPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createApiKeyApiApiKeysPost>>,
  TError,
  CreateApiKeyApiApiKeysPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateApiKeyApiApiKeysPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createApiKeyApiApiKeysPost>>,
    CreateApiKeyApiApiKeysPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createApiKeyApiApiKeysPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApiKeyApiApiKeysPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createApiKeyApiApiKeysPost>>
>;
export type CreateApiKeyApiApiKeysPostMutationBody = ApiKeyCreateRequest;
export type CreateApiKeyApiApiKeysPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateApiKeyApiApiKeysPostMutationVariables = {
  data: ApiKeyCreateRequest;
};

/**
 * @summary Create Api Key
 */
export const useCreateApiKeyApiApiKeysPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createApiKeyApiApiKeysPost>>,
      TError,
      CreateApiKeyApiApiKeysPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createApiKeyApiApiKeysPost>>,
  TError,
  CreateApiKeyApiApiKeysPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateApiKeyApiApiKeysPostMutationOptions(options),
    queryClient,
  );
};
export type revokeApiKeyApiApiKeysKeyIdDeleteResponse200 = {
  data: RevokeApiKeyApiApiKeysKeyIdDelete200;
  status: 200;
};

export type revokeApiKeyApiApiKeysKeyIdDeleteResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type revokeApiKeyApiApiKeysKeyIdDeleteResponseSuccess =
  revokeApiKeyApiApiKeysKeyIdDeleteResponse200 & {
    headers: Headers;
  };
export type revokeApiKeyApiApiKeysKeyIdDeleteResponseError =
  revokeApiKeyApiApiKeysKeyIdDeleteResponse422 & {
    headers: Headers;
  };

export type revokeApiKeyApiApiKeysKeyIdDeleteResponse =
  | revokeApiKeyApiApiKeysKeyIdDeleteResponseSuccess
  | revokeApiKeyApiApiKeysKeyIdDeleteResponseError;

export const getRevokeApiKeyApiApiKeysKeyIdDeleteUrl = (keyId: string) => {
  return `/api/api-keys/${keyId}`;
};

/**
 * Revoke a gateway API key. The internal service key cannot be revoked.
 * The revoke is recorded after the gateway accepted it (TRA-1626); a
 * refused revoke of the service key is recorded as denied.
 * @summary Revoke Api Key
 */
export const revokeApiKeyApiApiKeysKeyIdDelete = async (
  keyId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<revokeApiKeyApiApiKeysKeyIdDeleteResponse> => {
  return orvalFetch<revokeApiKeyApiApiKeysKeyIdDeleteResponse>(
    getRevokeApiKeyApiApiKeysKeyIdDeleteUrl(keyId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRevokeApiKeyApiApiKeysKeyIdDeleteMutationKey = () =>
  ["revokeApiKeyApiApiKeysKeyIdDelete"] as const;

export const getRevokeApiKeyApiApiKeysKeyIdDeleteMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeApiKeyApiApiKeysKeyIdDelete>>,
    TError,
    RevokeApiKeyApiApiKeysKeyIdDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeApiKeyApiApiKeysKeyIdDelete>>,
  TError,
  RevokeApiKeyApiApiKeysKeyIdDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getRevokeApiKeyApiApiKeysKeyIdDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeApiKeyApiApiKeysKeyIdDelete>>,
    RevokeApiKeyApiApiKeysKeyIdDeleteMutationVariables
  > = (props) => {
    const { keyId } = props ?? {};

    return revokeApiKeyApiApiKeysKeyIdDelete(keyId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeApiKeyApiApiKeysKeyIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeApiKeyApiApiKeysKeyIdDelete>>
>;

export type RevokeApiKeyApiApiKeysKeyIdDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type RevokeApiKeyApiApiKeysKeyIdDeleteMutationVariables = {
  keyId: string;
};

/**
 * @summary Revoke Api Key
 */
export const useRevokeApiKeyApiApiKeysKeyIdDelete = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revokeApiKeyApiApiKeysKeyIdDelete>>,
      TError,
      RevokeApiKeyApiApiKeysKeyIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof revokeApiKeyApiApiKeysKeyIdDelete>>,
  TError,
  RevokeApiKeyApiApiKeysKeyIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getRevokeApiKeyApiApiKeysKeyIdDeleteMutationOptions(options),
    queryClient,
  );
};
